export default "__VITE_ASSET__Mjn16dGW__"